import { gql as contentfulGQL } from '@apollo/client'

export const GET_SALES_QUERY = contentfulGQL/* GraphQL */ `
  query getSales($locale: String, $preview: Boolean!) {
    saleCollection(locale: $locale, preview: $preview) {
      items {
        sys {
          id
          publishedVersion
        }
        name
        abbreviatedPitch
        pitch
        startDate
        endDate
        category
        promotionsCollection(limit: 10) {
          items {
            sys {
              id
              publishedVersion
            }
            name
            bimId
            promoCode
          }
        }
        saleCopyExperimentCollection(limit: 10) {
          items {
            ... on GrowthbookExperimentMappings {
              sys {
                id
              }
              rolloutVariationId
            }
            ... on SaleText {
              sys {
                id
              }
              pitch
              abbreviatedPitch
              saleBannerText
            }
          }
        }
        showSaleBanner
        saleBannerIcon
        saleBannerText
        showSaleBannerCountdown
        saleBannerUrl
      }
    }
  }
`
